import React, { useState, useEffect } from 'react';
import { LuActivity, LuUser } from "react-icons/lu";
import './Scandinavian.css'
import { makeApiCall } from './AssessmentCall';
import { useAlert } from 'react-alert';
import { IoPrintOutline } from "react-icons/io5";
import AssessmentPreview from './NeuroAssessmentPreview';

const ReAssessment = ({ data, type, assessment_id, onSubmit, show, selectedAssessment }) => {
    const alert = useAlert()
    const [info, setInfo] = useState({
        therapy_consultation: data?.therapy_id || '',
        id: data?.id || '',
        name: data?.name || '',
        age: data?.age || '',
        gender: data?.gender || '',
        hand_dominance: 'Right',
        therapy_type: type,
        balance: '',
        gait: ''
    });
    const [loading, setLoading] = useState(false);
    const [assessmentScores, setAssessmentScores] = useState({
        shoulderFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        shoulderExtensors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        shoulderIr: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        shoulderEr: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        shoulderAbductors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        shoulderAdductors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        elbowFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        elbowExtensors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        wristFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        wristExtensors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        hipFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        hipExtensors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        hipAbductors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        hipAdductors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        kneeFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        kneeExtensor: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        dorsiFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
        plantarFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null }
    });
    const [showPreview, setShowPreview] = useState({
        show: false,
        showSubmitButton: false,
        onSubmit: () => { }
    });

    // Load selected assessment data when in readOnly mode
    useEffect(() => {
        if (show === 'readOnly' && selectedAssessment) {
            // Update info with selected assessment data
            setInfo(prev => ({
                ...prev,
                hand_dominance: selectedAssessment.hand_dominance || 'Right',
                therapy_type: type,
                balance: selectedAssessment.balance || '',
                gait: selectedAssessment.gait || ''
            }));

            // Load motor function data if available
            if (selectedAssessment.motor_function && Array.isArray(selectedAssessment.motor_function)) {
                const newAssessmentScores = { ...assessmentScores };

                selectedAssessment.motor_function.forEach(motor => {
                    if (newAssessmentScores[motor.muscle]) {
                        newAssessmentScores[motor.muscle][`mmt_${motor.side}`] = motor.mmt;
                        newAssessmentScores[motor.muscle][`rom_${motor.side}`] = motor.rom;
                        newAssessmentScores[motor.muscle][`tone_${motor.side}`] = motor.tone;
                    }
                });

                setAssessmentScores(newAssessmentScores);
            }
        } else if (show === 'post') {
            // Reset form for new assessment
            setInfo(prev => ({
                ...prev,
                hand_dominance: 'Right',
                therapy_type: type,
                balance: '',
                gait: ''
            }));
            setAssessmentScores({
                shoulderFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                shoulderExtensors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                shoulderIr: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                shoulderEr: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                shoulderAbductors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                shoulderAdductors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                elbowFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                elbowExtensors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                wristFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                wristExtensors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                hipFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                hipExtensors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                hipAbductors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                hipAdductors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                kneeFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                kneeExtensor: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                dorsiFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null },
                plantarFlexors: { mmt_rt: null, mmt_lt: null, rom_rt: null, rom_lt: null, tone_rt: null, tone_lt: null }
            });
        }
    }, [show, selectedAssessment, type]);

    const muscleGroups = [
        { key: 'shoulderFlexors', label: 'SHOULDER FLEXORS' },
        { key: 'shoulderExtensors', label: 'SHOULDER EXTENSORS' },
        { key: 'shoulderIr', label: 'SHOULDER IR' },
        { key: 'shoulderEr', label: 'SHOULDER ER' },
        { key: 'shoulderAbductors', label: 'SHOULDER ABDUCTORS' },
        { key: 'shoulderAdductors', label: 'SHOULDER ADDUCTORS' },
        { key: 'elbowFlexors', label: 'ELBOW FLEXORS' },
        { key: 'elbowExtensors', label: 'ELBOW EXTENSORS' },
        { key: 'wristFlexors', label: 'WRIST FLEXORS' },
        { key: 'wristExtensors', label: 'WRIST EXTENSORS' },
        { key: 'hipFlexors', label: 'HIP FLEXORS' },
        { key: 'hipExtensors', label: 'HIP EXTENSORS' },
        { key: 'hipAbductors', label: 'HIP ABDUCTORS' },
        { key: 'hipAdductors', label: 'HIP ADDUCTORS' },
        { key: 'kneeFlexors', label: 'KNEE FLEXORS' },
        { key: 'kneeExtensor', label: 'KNEE EXTENSOR' },
        { key: 'dorsiFlexors', label: 'DORSI FLEXORS' },
        { key: 'plantarFlexors', label: 'PLANTAR FLEXORS' }
    ];

    const mmtOptions = [
        { value: 0, label: '0 - No contraction' },
        { value: 1, label: '1 - Trace' },
        { value: 2, label: '2 - Poor' },
        { value: 3, label: '3 - Fair' },
        { value: 4, label: '4 - Good' },
        { value: 5, label: '5 - Normal' }
    ];

    const romOptions = [
        { value: 'WNL', label: 'WNL' },
        { value: 'Limited', label: 'Limited' },
        { value: 'Restricted', label: 'Restricted' },
        { value: 'Contracture', label: 'Contracture' }
    ];

    const toneOptions = [
        { value: 0, label: 'Flaccid' },
        { value: 1, label: 'Hypotonic' },
        { value: 2, label: 'Normal' },
        { value: 3, label: 'Hypertonic' },
        { value: 4, label: 'Spastic' }
    ];

    // Function to prepare data for preview component
    const prepareFormDataForPreview = () => {
        // Convert assessmentScores back to motor_function array format
        const motorAssessment = [];
        Object.entries(assessmentScores).forEach(([muscleGroup, values]) => {
            const isLeftEmpty = values.rom_lt == null && values.mmt_lt == null && values.tone_lt == null;
            const isRightEmpty = values.rom_rt == null && values.mmt_rt == null && values.tone_rt == null;

            // Skip if all values for both sides are null
            if (isLeftEmpty && isRightEmpty) return;

            if (!isLeftEmpty) {
                motorAssessment.push({
                    muscle: muscleGroup,
                    side: 'lt',
                    rom: values.rom_lt ?? null,
                    mmt: values.mmt_lt ?? null,
                    tone: values.tone_lt ?? null,
                });
            }

            if (!isRightEmpty) {
                motorAssessment.push({
                    muscle: muscleGroup,
                    side: 'rt',
                    rom: values.rom_rt ?? null,
                    mmt: values.mmt_rt ?? null,
                    tone: values.tone_rt ?? null,
                });
            }
        });

        // Return the structured data that AssessmentPreview expects
        return {
            // Basic patient info
            id: info.id,
            name: info.name,
            age: info.age,
            gender: info.gender,
            hand_dominance: info.hand_dominance,

            // Assessment specific data
            balance: info.balance,
            gait: info.gait,
            therapy_type: info.therapy_type,

            // Motor function data in the format expected by preview
            motor_function: motorAssessment,

            // Add creation date if it's a selected assessment
            ...(selectedAssessment && { created_at: selectedAssessment.created_at })
        };
    };

    const handleAssessmentChange = (muscleKey, assessmentType, side, value) => {
        if (show === 'readOnly') return; // Prevent changes in read-only mode

        setAssessmentScores(prev => ({
            ...prev,
            [muscleKey]: {
                ...prev[muscleKey],
                [`${assessmentType}_${side}`]: assessmentType === 'mmt' || assessmentType === 'tone' ? parseInt(value) : value
            }
        }));
    };

    const handleChange = (e) => {
        if (show === 'readOnly') return; // Prevent changes in read-only mode

        const { name, value } = e.target;
        setInfo(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCancel = () => {
        window.scrollTo({ top: 10, behavior: 'smooth' });
    }
    const handleButtonClick = () => {
        setShowPreview({
            show: true,
            showSubmitButton: true,
            onSubmit: handleSubmit,
        });
    };

    const handleSubmit = async () => {
        setShowPreview({
            show: false,
            showSubmitButton: false,
            onSubmit: () => { }
        });
        setLoading(true);
        if (show === 'readOnly') return;
        if (info.therapy_type === '') {
            alert.error('Add therapy type')
        } else {
            const motorAssessment = [];

            Object.entries(assessmentScores).forEach(([muscleGroup, values]) => {
                const isLeftEmpty = values.rom_lt == null && values.mmt_lt == null && values.tone_lt == null;
                const isRightEmpty = values.rom_rt == null && values.mmt_rt == null && values.tone_rt == null;

                // Skip if all values for both sides are null
                if (isLeftEmpty && isRightEmpty) return;

                if (!isLeftEmpty) {
                    motorAssessment.push({
                        muscle: muscleGroup,
                        side: 'lt',
                        rom: values.rom_lt ?? null,
                        mmt: values.mmt_lt ?? null,
                        tone: values.tone_lt ?? null,
                    });
                }

                if (!isRightEmpty) {
                    motorAssessment.push({
                        muscle: muscleGroup,
                        side: 'rt',
                        rom: values.rom_rt ?? null,
                        mmt: values.mmt_rt ?? null,
                        tone: values.tone_rt ?? null,
                    });
                }
            });

            const payload = {
                assessment_id: assessment_id,
                therapy_consultation: info.therapy_consultation,
                patient: +info.id,
                assessment_form: 'reassess',
                assessment_type: info.therapy_type,
                motor_function: motorAssessment,
                hand_dominance: info.hand_dominance,
                balance: info.balance,
                gait: info.gait
            };

            try {
                const result = await makeApiCall({
                    method: 'post',
                    endpoint: '/api/v1/patient/therapy-assessment/',
                    data: payload,
                });
                if (result) { setLoading(false) }
                if (result.success) {
                    handleCancel()
                    onSubmit()
                    alert.success('Assessment saved successfully!');
                } else {
                    alert.error(result.error || 'Failed to Save');
                }
            } catch (err) {
                console.error(err);
                alert.error('Error while saving assessment');
                setLoading(false)
            }
        }
    };

    const isReadOnly = show === 'readOnly';
    const getSelectValue = (value) => {
        return value !== null && value !== undefined ? value : '';
    };

    return (
        <div className='assessment-section'>
            <div className="general-form-content">
                <div className="section-header">
                    <h2>{isReadOnly ? 'Assessment Details' : 'Re-assessment'}</h2>
                    {isReadOnly && selectedAssessment && (
                        <p style={{ fontSize: '14px', color: '#666', margin: '5px 0' }}>
                            Created: {new Date(selectedAssessment.created_at).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                            })}
                        </p>
                    )}
                    <IoPrintOutline
                        style={{ marginLeft: 'auto', cursor: 'pointer', fontSize: '20px' }}
                        onClick={() => setShowPreview({
                            show: true,
                            showSubmitButton: false,
                            onSubmit: () => { handleSubmit() }
                        })}
                        title="Print Form"
                    />
                </div>

                <div className="section patient-information">
                    <div className="section-header">
                        <LuUser className="section-icon" />
                        <h3>Demographic data</h3>
                    </div>
                    <div className="input-row">
                        <div className="input-group-physio">
                            <label>Patient ID</label>
                            <input
                                type="text"
                                value={data?.id}
                                disabled
                            />
                        </div>
                        <div className="input-group-physio">
                            <label>Name</label>
                            <input
                                type="text"
                                value={data?.name}
                                disabled
                            />
                        </div>
                        <div className="input-group-physio">
                            <label>Age</label>
                            <input
                                type="number"
                                value={data?.age}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="input-row">
                        <div className="input-group-physio">
                            <label>Gender</label>
                            <input value={data?.gender} disabled />
                        </div>
                        <div className="input-group-physio">
                            <label>Hand dominance</label>
                            <select
                                name="hand_dominance"
                                value={info.hand_dominance}
                                onChange={handleChange}
                                disabled={isReadOnly}
                                isClearable={false}
                            >
                                <option value="Left">Left</option>
                                <option value="Right">Right</option>
                                <option value="Ambidextrous">Ambidextrous</option>
                            </select>
                        </div>
                    </div>
                    <div className="input-group-physio">
                        <label>Balance</label>
                        <input
                            type="text"
                            name="balance"
                            value={info.balance}
                            onChange={handleChange}
                            placeholder="balance..."
                            disabled={isReadOnly}
                        />
                    </div>
                    <div className="input-group-physio">
                        <label>Gait</label>
                        <input
                            type="text"
                            name="gait"
                            value={info.gait}
                            onChange={handleChange}
                            placeholder="gait..."
                            disabled={isReadOnly}
                        />
                    </div>
                </div>

                <div className="section-header">
                    <h2>MOTOR EXAMINATION</h2>
                </div>
                <div className="assessment-table">
                    <table className="motor-examination-table">
                        <thead>
                            <tr>
                                <th className="muscle-header" rowSpan="2" style={{ width: '150px' }}>MUSCLE</th>
                                <th className="assessment-header" colSpan="2">MMT</th>
                                <th className="assessment-header" colSpan="2">ROM</th>
                                <th className="assessment-header" colSpan="2">TONE</th>
                            </tr>
                            <tr>
                                <th className="side-header">RT</th>
                                <th className="side-header">LT</th>
                                <th className="side-header">RT</th>
                                <th className="side-header">LT</th>
                                <th className="side-header">RT</th>
                                <th className="side-header">LT</th>
                            </tr>
                        </thead>
                        <tbody>
                            {muscleGroups.map((muscle, index) => (
                                <tr key={index} className="motor-examination-row">
                                    <td className="muscle-name-cell">
                                        <strong>{muscle.label}</strong>
                                    </td>
                                    {/* MMT Columns */}
                                    <td className="assessment-select-cell">
                                        <select
                                            value={getSelectValue(assessmentScores[muscle.key].mmt_rt)}
                                            onChange={(e) => handleAssessmentChange(muscle.key, 'mmt', 'rt', e.target.value)}
                                            className="assessment-select"
                                            disabled={isReadOnly}
                                        >
                                            <option value="">Select</option>
                                            {mmtOptions.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td className="assessment-select-cell">
                                        <select
                                            value={getSelectValue(assessmentScores[muscle.key].mmt_lt)}
                                            onChange={(e) => handleAssessmentChange(muscle.key, 'mmt', 'lt', e.target.value)}
                                            className="assessment-select"
                                            disabled={isReadOnly}
                                        >
                                            <option value="">Select</option>
                                            {mmtOptions.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    {/* ROM Columns */}
                                    <td className="assessment-select-cell">
                                        <select
                                            value={getSelectValue(assessmentScores[muscle.key].rom_rt)}
                                            onChange={(e) => handleAssessmentChange(muscle.key, 'rom', 'rt', e.target.value)}
                                            className="assessment-select"
                                            disabled={isReadOnly}
                                        >
                                            <option value="">Select</option>
                                            {romOptions.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td className="assessment-select-cell">
                                        <select
                                            value={getSelectValue(assessmentScores[muscle.key].rom_lt)}
                                            onChange={(e) => handleAssessmentChange(muscle.key, 'rom', 'lt', e.target.value)}
                                            className="assessment-select"
                                            disabled={isReadOnly}
                                        >
                                            <option value="">Select</option>
                                            {romOptions.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    {/* Tone Columns */}
                                    <td className="assessment-select-cell">
                                        <select
                                            value={getSelectValue(assessmentScores[muscle.key].tone_rt)}
                                            onChange={(e) => handleAssessmentChange(muscle.key, 'tone', 'rt', e.target.value)}
                                            className="assessment-select"
                                            disabled={isReadOnly}
                                        >
                                            <option value="">Select</option>
                                            {toneOptions.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td className="assessment-select-cell">
                                        <select
                                            value={getSelectValue(assessmentScores[muscle.key].tone_lt)}
                                            onChange={(e) => handleAssessmentChange(muscle.key, 'tone', 'lt', e.target.value)}
                                            className="assessment-select"
                                            disabled={isReadOnly}
                                        >
                                            <option value="">Select</option>
                                            {toneOptions.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="assessment-legends">
                    <div className="legend-section">
                        <h4>MMT Scale:</h4>
                        <div className="legend-items">
                            <span className="legend-item">0 - No contraction</span>
                            <span className="legend-item">1 - Trace</span>
                            <span className="legend-item">2 - Poor</span>
                            <span className="legend-item">3 - Fair</span>
                            <span className="legend-item">4 - Good</span>
                            <span className="legend-item">5 - Normal</span>
                        </div>
                    </div>
                    <div className="legend-section">
                        <h4>ROM Scale:</h4>
                        <div className="legend-items">
                            <span className="legend-item">WNL - Within Normal Limits</span>
                            <span className="legend-item">Limited - Reduced range</span>
                            <span className="legend-item">Restricted - Significantly limited</span>
                            <span className="legend-item">Contracture - Fixed limitation</span>
                        </div>
                    </div>
                    <div className="legend-section">
                        <h4>Tone Scale:</h4>
                        <div className="legend-items">
                            <span className="legend-item">0 - Flaccid</span>
                            <span className="legend-item">1 - Hypotonic</span>
                            <span className="legend-item">2 - Normal</span>
                            <span className="legend-item">3 - Hypertonic</span>
                            <span className="legend-item">4 - Spastic</span>
                        </div>
                    </div>
                </div>

                {!isReadOnly && (
                    <div className="general-form-actions">
                        <button type="button" className="cancel-btn" onClick={handleCancel}>Cancel</button>
                        <button type="button" className="submit-btn" onClick={handleButtonClick} disabled={loading} style={{ cursor: loading ? 'wait' : 'pointer' }}>
                            {loading ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                )}
            </div>
            {showPreview.show && (
                <AssessmentPreview
                    formData={prepareFormDataForPreview()}
                    handleSubmit={showPreview.onSubmit}
                    formType='reassess'
                    onClose={() => setShowPreview({ show: false })}
                    showSubmitButton={showPreview.showSubmitButton}
                />
            )}
        </div >
    );
};

export default ReAssessment;